import { useState, useEffect } from 'react'
import { uploadImages } from '../../services/api'

export const useCNHScreen = (creditPath, goToNextScreen, setIsLoading) => {
  const [files, setFiles] = useState([])
  const [filesUploaded, setFilesUploaded] = useState([])

  useEffect(() => {
    setFilesUploaded(creditPath?.readPersonalDocument?.map(({ data, ...file }) => ({ url: data, ...file })) || [])
  }, [creditPath])

  const onClickNextScreen = async () => {
    setIsLoading(true)
    const urls = await uploadImages(files, { documentType: 'personal-document' })

    goToNextScreen({
      data: [...filesUploaded, ...urls],
    })
  }

  return [files, setFiles, filesUploaded, onClickNextScreen, setFilesUploaded]
}
